/*
  © 2024–2026 Atlas PHM
  Independently developed software. All rights reserved.
*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/main.css';
import './styles/print.css';
import './styles/story-ui.css';
import './styles/experiences.css';
import './styles/hub.css';
import { initializeInstrumentation } from './mapping';

// Initialize mapping instrumentation for devtools
initializeInstrumentation();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
